.shell,
.detail {
  position: relative;
  z-index: 2;
  width: min(1400px, 94vw);
  margin: 0 auto;
  padding: clamp(24px, 5vw, 56px) clamp(20px, 4vw, 40px) 80px;
  font-family: var(--token-font-ui);
  color: var(--token-text-primary);
}

.header {
  margin-bottom: 28px;
  text-align: center;
}

.heading,
.pageHeading {
  margin: 0 0 6px;
  font-family: var(--token-font-display);
  font-size: clamp(36px, 5vw, 56px);
  color: #fefdf6;
  text-shadow:
    0 2px 4px rgba(8, 18, 12, 0.55),
    0 6px 20px rgba(8, 18, 12, 0.45);
  letter-spacing: 0.5px;
}

.pageHeading {
  font-size: clamp(32px, 4.4vw, 52px);
}

.title {
  margin: 0;
  font-family: var(--token-font-display);
  font-size: clamp(24px, 3vw, 36px);
  color: #fefdf6;
  text-shadow:
    0 2px 4px rgba(8, 18, 12, 0.55),
    0 6px 20px rgba(8, 18, 12, 0.45);
  letter-spacing: 0.5px;
  overflow-wrap: anywhere;
}

.subtitle,
.meta,
.bodyText {
  margin: 0;
  font-family: var(--token-font-body);
  color: rgba(255, 255, 255, 0.95);
  text-shadow:
    0 1px 4px rgba(8, 18, 12, 0.55),
    0 2px 10px rgba(8, 18, 12, 0.4);
  font-size: 16px;
  font-weight: 500;
}

.meta {
  margin-top: 4px;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.bodyText {
  margin-top: 16px;
  text-align: center;
}

.tabs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px;
  margin-bottom: 24px;
  border-radius: 999px;
}

.tab {
  flex: 0 0 auto;
  min-height: 40px;
  padding: 8px 22px;
  border-radius: 999px;
  border: none;
  background: transparent;
  color: var(--token-text-primary);
  text-shadow:
    0 1px 0 rgba(255, 255, 255, 0.65),
    0 0 8px rgba(255, 255, 255, 0.4);
  font-family: var(--token-font-ui);
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition:
    background 120ms ease,
    color 120ms ease;
}

.tab:hover {
  background: rgba(255, 255, 255, 0.32);
}

.tabActive {
  background: rgba(255, 255, 255, 0.95);
  color: #1f2933;
  text-shadow: none;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.logout {
  margin-left: auto;
  min-height: 40px;
  padding: 8px 18px;
  border-radius: 999px;
  border: 1px solid rgba(8, 18, 12, 0.18);
  background: rgba(255, 255, 255, 0.5);
  color: var(--token-text-primary);
  font-family: var(--token-font-ui);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition:
    background 120ms ease,
    box-shadow 120ms ease;
}

.logout:hover {
  background: rgba(255, 255, 255, 0.78);
}

.body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.schoolToolbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.sectionHead,
.groupHead {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.sectionTitle {
  margin: 0;
  font-family: var(--token-font-display);
  font-size: 22px;
  color: var(--token-text-primary);
}

.schoolToolbar .sectionTitle,
.groupHead .sectionTitle {
  color: #fefdf6;
  text-shadow:
    0 1px 4px rgba(8, 18, 12, 0.55),
    0 2px 10px rgba(8, 18, 12, 0.4);
}

.panel .sectionTitle {
  color: var(--token-text-primary);
  text-shadow: none;
}

.sectionHint {
  margin: 2px 0 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.92);
  text-shadow: 0 1px 4px rgba(8, 18, 12, 0.45);
  line-height: 1.4;
}

.panel .sectionHint {
  color: rgba(28, 38, 32, 0.7);
  text-shadow: none;
}

.searchLabel {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: min(320px, 100%);
  color: #fefdf6;
  font-size: 13px;
  font-weight: 700;
  text-shadow: 0 1px 4px rgba(8, 18, 12, 0.45);
}

.searchInput {
  min-height: 44px;
  width: 100%;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.55);
  background: rgba(255, 255, 255, 0.82);
  color: var(--token-text-primary);
  font: inherit;
  padding: 8px 16px;
  outline: none;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.searchInput:focus {
  border-color: var(--token-accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--token-accent) 30%, transparent);
}

.schoolGrid {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(min(320px, 100%), 1fr));
}

.schoolCard {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding: 0;
  overflow: hidden;
}

.schoolCardButton {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  width: 100%;
  min-height: 116px;
  padding: 22px 18px 18px 24px;
  border: none;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 120ms ease;
}

.schoolCardButton:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1);
}

.schoolCardButton:disabled {
  cursor: default;
  opacity: 1;
}

.schoolCardText {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.schoolName {
  font-family: var(--token-font-display);
  font-size: 22px;
  color: var(--token-text-primary);
  letter-spacing: 0.2px;
  overflow-wrap: anywhere;
}

.schoolMeta {
  font-size: 14px;
  color: rgba(28, 38, 32, 0.78);
}

.tenantId {
  display: block;
  max-width: 100%;
  font-family: var(--token-font-mono, ui-monospace, SFMono-Regular, monospace);
  font-size: 12px;
  color: rgba(28, 38, 32, 0.58);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schoolStats {
  display: grid;
  gap: 8px;
}

.schoolStat {
  min-width: 96px;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.58);
  text-align: center;
}

.schoolStat strong {
  display: block;
  font-family: var(--token-font-display);
  font-size: 22px;
  line-height: 1;
}

.schoolStat span {
  display: block;
  margin-top: 4px;
  font-size: 11px;
  font-weight: 700;
  color: rgba(28, 38, 32, 0.62);
}

.schoolFooter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 8px 14px 14px;
  margin-top: auto;
}

.groupSection {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 10px;
}

.count {
  display: inline-block;
  min-width: 26px;
  padding: 3px 10px;
  border-radius: 999px;
  background: var(--token-accent);
  color: #1a1a1a;
  font-size: 14px;
  font-family: var(--token-font-ui);
  font-weight: 800;
  text-align: center;
  white-space: nowrap;
}

.empty {
  padding: 22px 26px;
  font-family: var(--token-font-body);
  color: var(--token-text-primary);
  width: 100%;
}

.empty p {
  margin: 0;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.back {
  padding-left: 14px;
  padding-right: 18px;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.secondaryPill {
  background: rgba(255, 255, 255, 0.5);
  color: var(--token-text-primary);
  border-color: rgba(8, 18, 12, 0.16);
  font-weight: 600;
}

.secondaryPill:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.78);
}

.panel {
  padding: 24px 26px;
}

.summary {
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: var(--token-font-body);
}

.summarySection {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.statsGrid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.stat,
.infoItem {
  min-width: 0;
  padding: 14px 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.58);
  border: 1px solid rgba(28, 38, 32, 0.1);
}

.statValue {
  display: block;
  font-family: var(--token-font-display);
  font-size: 26px;
  line-height: 1;
  color: var(--token-text-primary);
  overflow-wrap: anywhere;
}

.statLabel,
.infoLabel {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  font-weight: 700;
  color: rgba(28, 38, 32, 0.62);
}

.infoGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.infoValue {
  display: block;
  font-family: var(--token-font-display);
  font-size: 18px;
  color: var(--token-text-primary);
  overflow-wrap: anywhere;
}

.monoValue {
  font-family: var(--token-font-mono, ui-monospace, SFMono-Regular, monospace);
  font-size: 13px;
}

.statusApproved,
.statusBlocked,
.statusPending {
  align-self: center;
  justify-self: end;
  font-size: 13px;
  font-weight: 800;
  padding: 6px 11px;
  border-radius: 999px;
  white-space: nowrap;
}

.statusApproved {
  color: #14532d;
  background: rgba(22, 163, 74, 0.18);
}

.statusBlocked {
  color: #7f1d1d;
  background: rgba(220, 38, 38, 0.18);
}

.statusPending {
  color: #7c4a03;
  background: rgba(232, 155, 76, 0.24);
}

.approve {
  min-height: 40px;
  padding: 8px 18px;
  border-radius: 999px;
  border: none;
  background: var(--token-accent);
  color: #1a1a1a;
  font-family: var(--token-font-ui);
  font-weight: 800;
  font-size: 14px;
  cursor: pointer;
  transition:
    transform 120ms ease,
    box-shadow 120ms ease,
    opacity 120ms ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.approve:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}

.approve:disabled {
  opacity: 0.7;
  cursor: progress;
}

.errorLine {
  display: block;
  color: #b03a2e;
  font-size: 13px;
  margin: 8px 0 0;
}

.themeGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(172px, 1fr));
  gap: 12px;
}

.themeTile {
  position: relative;
  min-width: 0;
  min-height: 210px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  border: 1.5px solid rgba(28, 38, 32, 0.12);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.56);
  color: inherit;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition:
    transform 120ms ease,
    border-color 120ms ease,
    background 120ms ease,
    box-shadow 120ms ease,
    opacity 120ms ease;
}

.themeTile:hover:not(:disabled) {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.86);
}

.themeTile:disabled {
  cursor: default;
  opacity: 0.72;
}

.themeTileEnabled {
  border-color: var(--token-accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--token-accent) 25%, transparent);
}

.themePreview {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: 10px;
  background-color: #14241a;
  background-size: cover;
  background-position: center;
}

.themeMascot {
  position: absolute;
  left: 50%;
  bottom: 6px;
  height: 90%;
  max-width: 95%;
  object-fit: contain;
  transform: translateX(-50%);
  filter: drop-shadow(0 4px 8px rgba(8, 18, 12, 0.4));
}

.themeMeta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}

.themeName {
  min-width: 0;
  font-family: var(--token-font-display);
  font-size: 18px;
  line-height: 1.05;
  color: var(--token-text-primary);
  overflow-wrap: anywhere;
}

.themeTag {
  flex: 0 0 auto;
  padding: 3px 7px;
  border-radius: 999px;
  background: rgba(53, 83, 123, 0.16);
  color: #35537b;
  font-size: 11px;
  font-weight: 800;
}

.themeStateOn,
.themeStateOff {
  margin-top: auto;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.themeStateOn {
  color: var(--token-accent);
}

.themeStateOff {
  color: rgba(30, 42, 34, 0.5);
}

@media (max-width: 760px) {
  .shell,
  .detail {
    width: min(100%, 94vw);
    padding: 24px 16px 72px;
  }

  .tabs {
    border-radius: 24px;
  }

  .logout {
    margin-left: 0;
  }

  .schoolToolbar,
  .topbar {
    align-items: stretch;
    flex-direction: column;
  }

  .actions,
  .back,
  .secondaryPill {
    width: 100%;
  }

  .actions {
    justify-content: stretch;
  }

  .statusApproved,
  .statusBlocked,
  .statusPending {
    width: 100%;
    text-align: center;
  }

  .schoolCardButton {
    grid-template-columns: 1fr;
  }

  .schoolStats,
  .statsGrid,
  .infoGrid,
  .themeGrid {
    grid-template-columns: 1fr;
  }
}
